import PropTypes from 'prop-types'
import React from 'react'
import { adsStatues } from '../../../../shared/constants'
import { getProfileAdsQuery } from 'SRC/modules/users/Profile/selectors'
import { connect } from 'react-redux'
import { setProfileLoading, setNotifications } from 'SRC/modules/users/Profile/actions'
import Router from 'next/router'

export class Filter extends React.PureComponent {
  constructor (props) {
    super(props)
    this.formRef = React.createRef()
    this.paidStatus = {title: 'Promovisani oglasi', code: 'Paid'}
    this.state = { adStatus: 'Published' }
  }

  getOptions = () => {
    const allStatuses = []
    for (const status of adsStatues) {
      allStatuses.push({...status})
      // adding 'Paid' status, because it not status in backend
      if (status.code === adsStatues.PUBLISHED.code) {
        allStatuses.push(this.paidStatus)
      }
    }
    return allStatuses
  }

  onStatusChange = e => {
    const status = e.target.value
    this.setState({ adStatus: status })
    const hrefQuery = {page: 'oglasi', status}
    const href = {pathname: '/profile', query: hrefQuery}
    const as = {pathname: '/profil/oglasi/', query: { status }}
    Router.push(href, as)
  }

  render () {
    const defaultValue = this.props.query.status ? this.props.query.status : this.state.adStatus

    return (
      <form className='poruke-pretraga' ref={this.formRef}>
        <select name='status' onChange={this.onStatusChange} value={defaultValue}>
          {
            this.getOptions().map(
              item => <option key={item.code} value={item.code}>{`${item.title}`}</option>
            )
          }
        </select>
        <div className='input-pretraga'>
          {/* <SearchInput baseAs={baseAs} baseHref={baseHref} baseHrefQuery={baseHrefQuery} dropdownStyle='profile'
            profileAdStatus={this.state.adStatus} /> */}
        </div>
      </form>
    )
  }
}

Filter.propTypes = {
  query: PropTypes.shape({
    status: PropTypes.string,
    q: PropTypes.string
  })
}

const mapStateToProps = state => ({
  query: getProfileAdsQuery(state)
})

export default connect(mapStateToProps, {setProfileLoading, setNotifications})(Filter)
